<style lang="scss" scoped="scoped">
@keyframes twinkle {
  0% {
    opacity: 0.9;
  }

  100% {
    opacity: 0;
  }
}

.twinkle {
  animation: twinkle 0.8s infinite alternate;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;display: flex;flex-direction: column;">
    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;">
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
        {{ $t('zongtizhibiao') }}
      </p>
    </div>
    <div style="display: flex;flex-direction: column;flex: 1;">
      <div style="display: flex;align-items: center;">
        <p style="font-size: 36px;font-weight: bold;" :style="{ color: statusColors[tabsData.eqPoints['CurrentState']] }">{{ equipment.name }}</p>
        <div class="twinkle" style="width: 14px;height: 14px;margin-left: 24px;display: flex;justify-content: center;align-items: center;border-radius: 50%;" :style="{ background: statusColors2[tabsData.eqPoints['CurrentState']] }">
          <div style="width: 6px;height: 6px;border-radius: 50%" :style="{ background: statusColors[tabsData.eqPoints['CurrentState']] }"></div>
        </div>
        <p style="font-size: 14px;margin-left: 10px;" :style="{ color: statusColors[tabsData.eqPoints['CurrentState']] }">
          {{ $t(status[tabsData.eqPoints['CurrentState']]) }}
        </p>
      </div>
      <div ref="chart" id="chartAbout" :style="{ height: chartHeight + 'px' }" style="flex: 1;"></div>
      <div style="flex-shrink: 0;">
        <div style="display: flex;height: 50%;">
          <div style="width: 50%;text-align: center;">
            <p style="font-size: 14px;color: #C0C4CC;">{{ $t('jihuachanliang') }}</p>
            <p style="font-size: 22px;color: #ffffff;">
              {{ tabsData.eqPoints['PlanProduct'] ? (tabsData.eqPoints['PlanProduct'] * 1).toFixed(0) : '-' }}
            </p>
          </div>
          <div style="width: 50%;text-align: center;">
            <p style="font-size: 14px;color: #C0C4CC;">{{ $t('leijichanliang') }}</p>
            <p style="font-size: 22px;color: #ffffff;">
              {{ tabsData.eqPoints['CurrentProduct'] ? (tabsData.eqPoints['CurrentProduct'] * 1).toFixed(0) : '-' }}
            </p>
          </div>
        </div>
        <div style="display: flex;height: 50%;margin-top:8px;">
          <div style="width: 50%;text-align: center;">
            <p style="font-size: 14px;color: #C0C4CC;">{{ $t('kaijilv') }}</p>
            <p style="font-size: 22px;color: #ffffff;">{{ (tabsData.eqPoints['UpTimeRate'] * 1).toFixed(1) }}%</p>
          </div>
          <div style="width: 50%;text-align: center;">
            <p style="font-size: 14px;color: #C0C4CC;">{{ $t('jiadonglu') }}</p>
            <p style="font-size: 22px;color: #ffffff;">{{ (tabsData.eqPoints['TimeEfficency'] * 1).toFixed(1) }}%</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_workshop_equipment_about',
  components: {},
  props: {
    equipment: {
      type: Object,
      default: function() {
        return {};
      }
    },
    tabsData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      chart: null,
      options: null,
      chartHeight: 0,
      percent: 0,
      status: {
        '0': 'shengchanzhong',
        '1': 'kongxian',
        '3': 'guzhang',
        '-1': 'lixian'
      },
      statusColors: {
        '0': 'rgba(125, 255, 190, 1)',
        '1': 'rgba(255, 213, 128, 1)',
        '3': 'rgba(255, 128, 159, 1)',
        '-1': 'rgba(117, 130, 163, 1)'
      },
      statusColors2: {
        '0': 'rgba(125, 255, 190, 0.5)',
        '1': 'rgba(255, 213, 128, 0.5)',
        '3': 'rgba(255, 128, 159, 0.5)',
        '-1': 'rgba(117, 130, 163, 0.5)'
      }
    };
  },
  created() {},
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    //时间比最后的resize晚，这样就不会被打断导致动画不流畅
    setTimeout(() => {
      this.initChart();
    }, 500);
  },
  destroyed() {},
  methods: {
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.chartHeight = this.$refs.chart.offsetHeight;
        if (this.chart) {
          this.chart.resize();
        }
      }, 500);
    },
    initChart() {
      this.option = {
        backgroundColor: null,
        series: [
          {
            type: 'gauge',
            center: ['50%', '75%'],
            startAngle: 190,
            endAngle: -10,
            min: 0,
            max: 100,
            radius: '120%',
            splitNumber: 18,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#6FE5FF' // 25% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#1C70C6' // 0% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            },
            progress: {
              show: true,
              width: 14
            },
            pointer: {
              show: false
            },
            axisLine: {
              lineStyle: {
                width: 14,
                color: [[1, '#858A93']]
              }
            },
            axisTick: {
              distance: -22,
              splitNumber: 3,
              lineStyle: {
                width: 1,
                color: '#858A93'
              }
            },
            splitLine: {
              show: false,
              distance: -12,
              length: 12,
              lineStyle: {
                width: 1,
                color: '#858A93'
              }
            },
            axisLabel: {
              distance: 0,
              color: '#858A93',
              fontSize: 30,
              show: false
            },
            anchor: {
              show: false
            },

            title: {
              offsetCenter: [0, '-4%'],
              fontSize: 14,
              color: '#ffffff'
            },
            detail: {
              valueAnimation: false,
              width: '60%',
              lineHeight: 26,
              borderRadius: 8,
              offsetCenter: [0, '-34%'],
              fontSize: 20,
              fontWeight: 'bolder',
              formatter: value => {
                return value.toFixed(1) + '%';
              },
              color: '#ffffff'
            },
            data: [
              {
                value: this.percent
              }
            ]
          }
        ]
      };

      var chartDom = document.getElementById('chartAbout');
      this.chart = this.echarts.init(chartDom);
      this.option && this.chart.setOption(this.option);
      let setData = () => {
        if (this.tabsData.eqPoints['CurrentProduct'] && this.tabsData.eqPoints['PlanProduct']) {
          this.chart.setOption({
            series: [
              {
                data: [
                  {
                    value: ((this.tabsData.eqPoints['CurrentProduct'] / this.tabsData.eqPoints['PlanProduct']) * 100).toFixed(1),
                    name: this.$t('shengchanjindu')
                  }
                ]
              }
            ]
          });
        }
      };
      setData();

      setInterval(() => {
        setData();
      }, 10000);
    },
    initChart2() {
      this.option = {
        backgroundColor: '#26262A',
        title: {
          text: '{num|' + this.percent + '%}',
          x: '50%',
          y: '53%',
          textAlign: 'center',
          textStyle: {
            rich: {
              num: {
                fontWeight: '400',
                color: '#FFFFFF',
                fontFamily: 'D-DIN Exp',
                fontSize: 10
              }
            }
          }
        },
        series: [
          {
            type: 'gauge',
            radius: '130%', // 1行3个
            center: ['50%', '70%'],
            splitNumber: 4,
            // min: 0,
            max: 100,
            startAngle: 180,
            endAngle: 0,
            z: 99,
            // 线
            axisLine: {
              lineStyle: {
                width: 1,
                color: [[1, 'rgba(255,255,255,0)']]
              },
              detail: {
                formatter: '{value}'
              },
              data: [
                {
                  value: 50,
                  name: '1'
                }
              ]
            },
            //刻度标签。
            axisTick: {
              show: true,
              splitNumber: 8, //刻度的段落数
              lineStyle: {
                color: '#858A93',
                width: 2 //刻度的宽度
              },
              length: 12, //刻度的长度
              distance: 0
            },
            splitLine: {
              //文字和刻度的偏移量
              show: true,
              length: -15, //长度
              lineStyle: {
                color: '#858A93',
                width: 0
              }
            },
            // //刻度线文字
            axisLabel: {
              show: false,
              color: '#858A93',
              fontSize: 10,
              distance: -30
            },
            data: [
              {
                value: this.percent,
                name: this.$t('shengchanjindu'),
                itemStyle: {
                  color: '#fff'
                }
              }
            ],
            pointer: {
              show: false,
              length: '12%',
              radius: '50%',
              width: 12, //指针粗细
              offsetCenter: [0, -273]
            },
            detail: {
              show: false
            },
            title: {
              // 仪表盘标题。
              show: true,
              offsetCenter: [0, -5], // x, y，单位px
              textStyle: {
                color: '#C0C4CC',
                fontSize: 10, //表盘上的标题文字大小
                fontWeight: 400,
                fontFamily: 'Microsoft YaHei UI'
              }
            }
          },
          {
            name: 'jianbianhuan',
            type: 'pie', //渐变环
            radius: ['100%', '110%'],
            center: ['50%', '70%'],
            startAngle: 180,
            endAngle: 0,
            color: [
              {
                type: 'linear',
                x: 1,
                y: 0,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#6FE5FF' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#1C70C6' // 100% 处的颜色
                  }
                ]
              },
              'transparent'
            ],
            hoverAnimation: true,
            legendHoverLink: false,
            z: 10,
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              {
                value: 0
              },
              {
                value: 50
              }
            ]
          },
          {
            z: 11,
            name: '',
            type: 'gauge', //粗分割线
            radius: '140%',
            center: ['50%', '70%'],
            startAngle: 180,
            endAngle: 0,
            splitNumber: 20,
            hoverAnimation: true,
            axisTick: {
              show: false
            },
            splitLine: {
              length: 11,
              lineStyle: {
                width: 10,
                color: '#26262A' //26262A
              }
            },
            axisLabel: {
              show: false
            },
            pointer: {
              show: false
            },
            axisLine: {
              lineStyle: {
                opacity: 0
              }
            },
            detail: {
              show: false
            },
            data: [
              {
                value: 0,
                name: ''
              }
            ]
          },
          {
            type: 'pie', //纯色背景环
            radius: ['100%', '110%'],
            center: ['50%', '70%'],
            startAngle: 180,
            endAngle: 0,
            color: '#606672',
            hoverAnimation: true,
            legendHoverLink: false,
            z: 0,
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              {
                value: 0.1
              },
              {
                value: 1
              }
            ]
          }
        ]
      };

      var chartDom = document.getElementById('chartAbout');
      this.chart = this.echarts.init(chartDom);
      this.option && this.chart.setOption(this.option);
      let setData = () => {
        if (this.tabsData.eqPoints['CurrentProduct'] && this.tabsData.eqPoints['PlanProduct']) {
          this.chart.setOption({
            series: [
              {
                data: [
                  {
                    value: ((this.tabsData.eqPoints['CurrentProduct'] / this.tabsData.eqPoints['PlanProduct']) * 100).toFixed(1),
                    name: this.$t('shengchanjindu')
                  }
                ]
              }
            ]
          });
        }
      };
      setData();

      setInterval(() => {
        setData();
      }, 10000);
    }
  }
};
</script>
